module.exports = __webpack_public_path__ + "img/user_active.d9a592d6.svg";